import axios from "axios";

export default {
  async connexionExterieur(connexionForm) {
    let formData = new FormData();
    formData.set("username", connexionForm.email);
    formData.set("password", connexionForm.mdp);

    await axios.post(
      process.env.VUE_APP_BACKEND_API_URL + "/api/externe",
      formData
    );
  },

  async creationCompte(compteForm) {
    const response = await axios.post(
      process.env.VUE_APP_BACKEND_API_URL + "/api/creationCompte",
      compteForm
    );
    return response.data;
  },

  async getMDP(formulaire) {
    const response = await axios.post(
      process.env.VUE_APP_BACKEND_API_URL + "/api/oubliMdp",
      formulaire
    );
    return response.data;
  },

  async changePassword(changePassword) {
    await axios.post(
      process.env.VUE_APP_BACKEND_API_URL + "/api/changeMdp",
      changePassword
    );
  },

  async checkToken(token) {
    await axios.post(
      process.env.VUE_APP_BACKEND_API_URL + "/api/checkToken",
      token
    );
  }
};
